import {
  selectAllArticlesAndPrices,
  selectFrontendAppShowPrice,
  selectGroups,
  selectSelections,
  selectValues,
  selectVariables,
  selectPriceFormatter,
  addCallbacks,
  isNumberVariable,
} from '@k3/core'
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

export const ArticleList = (props: any) => {
  const bom = useSelector(selectAllArticlesAndPrices)
  const showPrice = useSelector(selectFrontendAppShowPrice)
  const variables = useSelector(selectVariables)
  const selections = useSelector(selectSelections)
  const values = useSelector(selectValues)
  const groups = useSelector(selectGroups)
  const priceFormatter = useSelector(selectPriceFormatter)

  const articleTableObject = {
    tableHead: {
      group: '<b>Reiter</b>',
      variable: '<b>Eigenschaft</b>',
      value: '<b>Auswahl</b>',
      price: '<b>Preis</b>',
    },
    tableBody: [
      ...groups
        .map((group, groupIndex) => {
          const sortedVariablesForGroup = variables
            .filter((variable) => variable.groupId === group.id)
            .sort((variable1, variable2) => variable1.sort - variable2.sort)
          return sortedVariablesForGroup.map((variable, variableIndex) => {
            const selectionForVariable = selections.find(
              (selection) => selection.variableId === variable.id
            )
            const valueForSelection = values.find(
              (value) => value.id === selectionForVariable?.valueId
            )
            const isNumberSelection = isNumberVariable(variable)
            const articleLineForVariable = bom.articleLines
              .filter((ao) => ao.article?.category === variable.key)
              .map((article) => article.priceTotal)
              .reduce((prev, current) => prev + current, 0)
            return {
              group: variableIndex === 0 ? group.label : '',
              variable: variable.label,
              value: isNumberSelection
                ? `${selectionForVariable!.data.inputValue} mm`
                : valueForSelection!.label,
              price:
                articleLineForVariable > 0
                  ? priceFormatter.format(articleLineForVariable)
                  : '',
            }
          })
        })
        .flat(),
    ],
    tableEnd: {
      group: '<b>Summe</b>',
      variable: '',
      value: '',
      price: `<b>${priceFormatter.format(bom.priceTotal)}</b>`,
    },
    caption: `* Leistungsangaben sind vorläufig`,
    total: priceFormatter.format(bom.priceTotal),
  }

  addCallbacks({
    saveConfiguration: (cfg) => {
      return {
        ...cfg,
        json: {
          ...cfg.json,
          pdfArticleList: articleTableObject,
        },
      }
    },
  })

  return (
    <Box component="div">
      <Typography
        variant="h5"
        component="h2"
        className="content"
        dangerouslySetInnerHTML={{
          __html: 'Preiliste',
        }}
      ></Typography>
      <br></br>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <InnerTableRow
              tableObject={articleTableObject.tableHead}
            ></InnerTableRow>
            {/* <TableRow>
              <TableCell>Reiter</TableCell>
              <TableCell>Eigenschaft</TableCell>
              <TableCell align="left">Getroffene Auswahl</TableCell>
              <TableCell align="left"></TableCell>
              <TableCell align="right">Preis</TableCell>
            </TableRow> */}
          </TableHead>
          <TableBody>
            {articleTableObject.tableBody.map((tableRow) => {
              return <InnerTableRow tableObject={tableRow}></InnerTableRow>
            })}
            <InnerTableRow
              tableObject={articleTableObject.tableEnd}
            ></InnerTableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="caption">{articleTableObject.caption}</Typography>
    </Box>
  )
}

const InnerTableRow = (props: {
  tableObject: {
    group: string
    variable: string
    value: string
    price: string
  }
}) => {
  return (
    <TableRow>
      <TableCell
        dangerouslySetInnerHTML={{
          __html: props.tableObject.group,
        }}
      ></TableCell>
      <TableCell
        dangerouslySetInnerHTML={{
          __html: props.tableObject.variable,
        }}
      ></TableCell>
      <TableCell
        dangerouslySetInnerHTML={{
          __html: props.tableObject.value,
        }}
      ></TableCell>
      <TableCell></TableCell>
      <TableCell
        align="right"
        dangerouslySetInnerHTML={{
          __html: props.tableObject.price,
        }}
      ></TableCell>
    </TableRow>
  )
}
